module.exports = __webpack_public_path__ + "img/banner_bot.317db135.png";